module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jerrold M. Packard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Jerrold Packard")]), _vm._v(" is the author of the best-selling "), _c('I', [_vm._v("Victoria's Daughters")]), _vm._v(", and most recently "), _c('I', [_vm._v("American Nightmare")]), _vm._v(". Mr. Packard lives in Vermont.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DI1sFh/images/9781466852785.jpg?1726444398176",
      "alt": "This image is the cover for the book Lincolns in the White House"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lincolns in the White House\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("From the day of Abraham Lincoln's inauguration, a nation divided by savage conflict confronted the new president. But what many don't know was that within the White House's walls, the Lincoln's family would soon find itself suffering turmoil mirroring that of the nation he led."), _c('br'), _c('br'), _vm._v("Savagely criticized for her extravagance by the American public and widely distrusted because of her southern roots, first lady Mary Lincoln's increasing instability would deeply strain her marriage and eventually end in her mental collapse. The couple was devastated when eleven-year-old Willie died in the White House of typhoid fever. Tad, the youngest son, remained the family joy despite his physical impairments. Though their son Robert's success at Harvard made his parents proud, his relationship with them was troubled and would result in a painful estrangement, one which would eventually permanently separate him from his mother. The president's assassination brutally crushed Mary's always-fragile spirits. After leaving the White House and following Tad's early death, the former first lady retreated into increasing eccentricity and seclusion until her death in 1882. A moving and poignant portrait of the family life of America's greatest president.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Griffin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0